import { useDialog, useGrid, UseGridReturnType } from "common";
import { createContext } from "react";
import {
  getSharingService,
  SharingFormItem,
  SharingListItem,
} from "./sharingApi";

export type UseSharingListReturnType = {
  connectItem?: SharingListItem;
  setConnectItem: Function; //(item?: SharingListItem)=>void;
  connectItemDialog: any;
  editItem?: SharingListItem;
  setEditItem: Function; //(item?: SharingListItem)=>void;
  editItemDialog: any;
} & UseGridReturnType;

export const SharingListContext = createContext<UseSharingListReturnType>(
  {} as UseSharingListReturnType
);

export default function useSharingList({
  waiver_id,
}: {
  waiver_id?: any;
}): UseSharingListReturnType {
  const service = getSharingService();
  const list = useGrid<SharingFormItem, SharingListItem>({
    comaSeparatedSortPrarms: true,
    storageType: waiver_id ? "none" : "urlParams",
    id: "Sharings",
    loadColumns: true,
    translationCategory: "Sharing",
    confirmAttribute: "name",
    defaultFilter: waiver_id
      ? {
          sharing_waivers: waiver_id,
        }
      : undefined,
    exportFilter: filter => ({
      SharingSearch: filter,
    }),
    ...service,
    loadOptions: undefined,
  });

  const [connectItem, setConnectItem, connectItemDialog] = useDialog();
  const [editItem, setEditItem, editItemDialog] = useDialog();

  return {
    ...list,
    connectItem,
    setConnectItem,
    connectItemDialog,
    editItem,
    setEditItem,
    editItemDialog,
  };
}
